import React from "react";
import { Card, Label } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { encodeClubUrl } from "../../helpers/clubHelper";
import ClubTeams from "../Club/ClubTeams";

const ClubCard = (
  { _id, name, country, state, teams, img, isActive, history },
  handleClick
) => {
  const imgFilename = name
    .replace(" ", "")
    .replace("'", "")
    .toLowerCase();
  const imgUrl = img || `/img/countries/${country}/${state}/${imgFilename}.png`;
  const teamIcons = <ClubTeams teams={teams} />;
  return (
    <Card
      centered
      header={name}
      meta={`${state}, ${country}`}
      description={teamIcons}
      image={imgUrl}
      key={_id}
      as={Link}
      to={encodeClubUrl({ name, country, state })}
      extra={
        isActive ? (
          ""
        ) : (
          <Label as="div" color="red" basic>
            Defunct
          </Label>
        )
      }
    />
  );
};

ClubCard.defaultProps = {
  history: {}
};

ClubCard.propTypes = {
  _id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default ClubCard;



// WEBPACK FOOTER //
// ./src/components/ClubList/ClubCard.js